export default function ActionItemsMock() {
  return (
    <img
      src="/images/landing-v2/features/action-items-panel.png"
      alt="Shadow detecting and handling action items live on a meeting"
      className="w-full select-none"
      draggable="false"
    />
  );
}
